import { Button } from 'antd';
import { RobotOutlined } from '@ant-design/icons';
import { useEffect, useState } from 'react';
import './ChatButton.css';

interface ChatButtonProps {
  onClick?: () => void;
  chatUrl?: string;
  className?: string;
  variant?: 'campaign' | 'task';
  showInitialAnimation?: boolean;
}

const ChatButton: React.FC<ChatButtonProps> = ({ 
  onClick, 
  chatUrl,
  className = '', 
  variant = 'campaign',
  showInitialAnimation = true
}) => {
  const [showAttention, setShowAttention] = useState(false);

  const buttonText = '行動啦 Action Now';

  useEffect(() => {
    if (showInitialAnimation) {
      // Start animation after a short delay to let page load
      const timer = setTimeout(() => {
        setShowAttention(true);
        // Remove animation class after animation completes
        setTimeout(() => {
          setShowAttention(false);
        }, 3000);
      }, 500);

      return () => clearTimeout(timer);
    }
  }, [showInitialAnimation]);

  // Check if it's mobile and we have a chat URL
  const isMobile = window.innerWidth <= 1200;
  
  const handleClick = () => {
    if (isMobile && chatUrl) {
      // Open in new tab on mobile
      window.open(chatUrl, '_blank', 'noopener,noreferrer');
    } else if (onClick) {
      // Use modal on desktop
      onClick();
    }
  };

  return (
    <Button
      type="primary"
      size="large"
      icon={<RobotOutlined />}
      onClick={handleClick}
      className={`chat-button ${showAttention ? 'initial-attention' : ''} ${className}`}
      title={buttonText}
      aria-label={buttonText}
    >
      <span className="chat-button-text">{buttonText}</span>
    </Button>
  );
};

export default ChatButton;